// GENERATED by scripts/gen-hooks.mjs. Do not edit by hand.
// 13 hooks for backend/agreements.

import { useBackend } from '../useBackend'

/** POST /api/agreements/bookInductionSession */
export function useBookInductionSession<T = any>() {
  return useBackend<T>('agreements/bookInductionSession')
}

/** POST /api/agreements/createAddendumRecords */
export function useCreateAddendumRecords<T = any>() {
  return useBackend<T>('agreements/createAddendumRecords')
}

/** POST /api/agreements/createInductionSession */
export function useCreateInductionSession<T = any>() {
  return useBackend<T>('agreements/createInductionSession')
}

/** POST /api/agreements/declineAddendum */
export function useDeclineAddendum<T = any>() {
  return useBackend<T>('agreements/declineAddendum')
}

/** POST /api/agreements/getAddendumInvitationPreview */
export function useGetAddendumInvitationPreview<T = any>() {
  return useBackend<T>('agreements/getAddendumInvitationPreview')
}

/** POST /api/agreements/getAgreementFileUrl */
export function useGetAgreementFileUrl<T = any>() {
  return useBackend<T>('agreements/getAgreementFileUrl')
}

/** POST /api/agreements/getAgreements */
export function useGetAgreements<T = any>() {
  return useBackend<T>('agreements/getAgreements')
}

/** POST /api/agreements/getDriverAgreements */
export function useGetDriverAgreements<T = any>() {
  return useBackend<T>('agreements/getDriverAgreements')
}

/** POST /api/agreements/getInductionBookable */
export function useGetInductionBookable<T = any>() {
  return useBackend<T>('agreements/getInductionBookable')
}

/** POST /api/agreements/markInductionAttendance */
export function useMarkInductionAttendance<T = any>() {
  return useBackend<T>('agreements/markInductionAttendance')
}

/** POST /api/agreements/reopenAddendum */
export function useReopenAddendum<T = any>() {
  return useBackend<T>('agreements/reopenAddendum')
}

/** POST /api/agreements/resendAddendum */
export function useResendAddendum<T = any>() {
  return useBackend<T>('agreements/resendAddendum')
}

/** POST /api/agreements/sendAddendumInvitations */
export function useSendAddendumInvitations<T = any>() {
  return useBackend<T>('agreements/sendAddendumInvitations')
}
